import React from 'react';

import { Box, Divider, Grid, SwipeableDrawer, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';

import RenderOps from './RenderOps';
import { KanbanColumn } from '../../@types/State';

const iOS =
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

interface Props {
  drawerOpen: boolean;
  toggleColumnDrawer: () => void;
  addColumnOp: (op: string) => void;
  deleteColumnOp: (op: string, column: KanbanColumn) => void;
  selectedColumn: KanbanColumn | null;
}

const OpsDrawer: React.FC<Props> = ({
  drawerOpen,
  toggleColumnDrawer,
  addColumnOp,
  deleteColumnOp,
  selectedColumn,
}) => {
  return (
    <SwipeableDrawer
      anchor='right'
      open={drawerOpen}
      onClose={toggleColumnDrawer}
      onOpen={toggleColumnDrawer}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
    >
      <Box
        sx={{
          paddingX: 1,
          paddingTop: 2,
        }}
      >
        <Typography variant='body1' mt={1} textAlign='center'>
          Tap &rsquo;sticky&rsquo; Ops below to assign them
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            width: isMobile ? '100vw' : '300px',
            py: 2,
            textAlign: 'center',
          }}
        >
          <Grid size={6}>
            <Typography variant='body2' gutterBottom>
              Duration Ops
            </Typography>
            <Divider sx={{ margin: 1 }} />
            <RenderOps
              isDuration={true}
              isEnemy={true}
              addColumnOp={addColumnOp}
              deleteColumnOp={deleteColumnOp}
              selectedColumn={selectedColumn}
            />
          </Grid>
          <Grid size={6}>
            <Typography variant='body2' gutterBottom>
              Instant Ops
            </Typography>
            <Divider sx={{ margin: 1 }} />
            <RenderOps
              isDuration={false}
              isEnemy={true}
              addColumnOp={addColumnOp}
              deleteColumnOp={deleteColumnOp}
              selectedColumn={selectedColumn}
            />
          </Grid>
        </Grid>
      </Box>
    </SwipeableDrawer>
  );
};

export default OpsDrawer;
